"use client";

import { c as _c } from "react/compiler-runtime";
import { HiChevronRight } from "react-icons/hi2";
import { ProgressBarLink } from "@/components/progress-bar";
import { Collapsible, CollapsibleContent } from "@/components/ui/collapsible";
import NewBadge from "@/components/ui/new-badge";
import { SidebarMenuButton, SidebarMenuItem, SidebarMenuSub, useSidebar } from "@/components/ui/sidebar";
import { SiteMapItem } from "@/config/sitemap";
import { cx } from "@/lib/tailwind-utils";
import { SidebarLeafItem, renderAlertBadge } from "./sidebar-leaf-item";
import { useNavigationSidebarOpenStore } from "@/stores/navigation-sidebar-store";
interface SidebarNavItemProps {
  item: SiteMapItem;
  currentRoute: string | undefined;
}

/**
 * Sidebar navigation item component.
 * Receives pre-filtered items (filtering is done in useMenuItems hook).
 * Handles rendering of both leaf items and collapsible parent items.
 */
export function SidebarNavItem(t0) {
  const $ = _c(63);
  const {
    item,
    currentRoute
  } = t0;
  const {
    setOpenMobile,
    isMobile
  } = useSidebar();
  const {
    expandedSections,
    toggleSection
  } = useNavigationSidebarOpenStore();
  const hasChildren = item.children && item.children.length > 0;
  const sectionId = item.name;
  let T0;
  let T1;
  let T2;
  let T3;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== currentRoute || $[1] !== expandedSections || $[2] !== hasChildren || $[3] !== isMobile || $[4] !== item || $[5] !== sectionId || $[6] !== setOpenMobile || $[7] !== toggleSection) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const isExpanded = expandedSections.includes(sectionId);
      const parentRouteRemoved = (item as SiteMapItem & {
        _parentRouteRemoved?: boolean;
      })._parentRouteRemoved;
      const visibleChildren = item.children?.filter(child => !child.hidden || currentRoute === child.route && !item.children?.some(sibling => !sibling.hidden && sibling.route === child.route)) ?? [];
      const childOwnsCurrentRoute = isExpanded && currentRoute !== undefined && visibleChildren.some(child_0 => child_0.route === currentRoute);
      const isActive = (currentRoute === item.route || currentRoute !== undefined && item.routeAliases?.includes(currentRoute) === true) && !childOwnsCurrentRoute;
      let t6;
      if ($[17] !== isMobile || $[18] !== setOpenMobile) {
        t6 = () => {
          if (isMobile) {
            setOpenMobile(false);
          }
        };
        $[17] = isMobile;
        $[18] = setOpenMobile;
        $[19] = t6;
      } else {
        t6 = $[19];
      }
      const handleNavClick = t6;
      if (!hasChildren || visibleChildren.length === 0) {
        let t7;
        if ($[20] !== currentRoute || $[21] !== item) {
          t7 = <SidebarLeafItem item={item} currentRoute={currentRoute} />;
          $[20] = currentRoute;
          $[21] = item;
          $[22] = t7;
        } else {
          t7 = $[22];
        }
        t5 = t7;
        break bb0;
      }
      let t7;
      if ($[23] !== item) {
        t7 = renderAlertBadge(item);
        $[23] = item;
        $[24] = t7;
      } else {
        t7 = $[24];
      }
      const alertBadge = t7;
      T3 = Collapsible;
      t3 = isExpanded;
      t4 = "group/collapsible";
      T2 = SidebarMenuItem;
      let t8;
      if ($[25] !== alertBadge || $[26] !== handleNavClick || $[27] !== isActive || $[28] !== item.icon || $[29] !== item.name || $[30] !== item.route || $[31] !== item.showNewBadge || $[32] !== parentRouteRemoved || $[33] !== sectionId || $[34] !== toggleSection) {
        t8 = item.route && !parentRouteRemoved ? <SidebarMenuButton asChild={true} isActive={isActive} tooltip={item.name} className="flex-1"><ProgressBarLink href={item.route} onClick={handleNavClick}><span className="text-caption-strong uppercase">{item.name}</span>{item.icon}{item.showNewBadge && <NewBadge />}{alertBadge}</ProgressBarLink></SidebarMenuButton> : <SidebarMenuButton onClick={() => toggleSection(sectionId)} tooltip={item.name} className="flex-1"><span className="text-caption-strong uppercase">{item.name}</span>{item.icon}{item.showNewBadge && <NewBadge />}{alertBadge}</SidebarMenuButton>;
        $[25] = alertBadge;
        $[26] = handleNavClick;
        $[27] = isActive;
        $[28] = item.icon;
        $[29] = item.name;
        $[30] = item.route;
        $[31] = item.showNewBadge;
        $[32] = parentRouteRemoved;
        $[33] = sectionId;
        $[34] = toggleSection;
        $[35] = t8;
      } else {
        t8 = $[35];
      }
      const t9 = isExpanded ? "Collapse" : "Expand";
      let t10;
      if ($[36] !== sectionId || $[37] !== toggleSection) {
        t10 = e => {
          e.preventDefault();
          e.stopPropagation();
          toggleSection(sectionId);
        };
        $[36] = sectionId;
        $[37] = toggleSection;
        $[38] = t10;
      } else {
        t10 = $[38];
      }
      const t11 = <HiChevronRight className={cx("h-4 w-4 transition-transform duration-200", isExpanded && "rotate-90")} />;
      let t12;
      if ($[39] !== t10 || $[40] !== t11 || $[41] !== t9) {
        t12 = <button type="button" className="px-2 py-1.5 text-foreground-secondary/70 hover:text-foreground" aria-label={t9} onClick={t10}>{t11}</button>;
        $[39] = t10;
        $[40] = t11;
        $[41] = t9;
        $[42] = t12;
      } else {
        t12 = $[42];
      }
      if ($[43] !== t12 || $[44] !== t8) {
        t2 = <div className="flex items-center">{t8}{t12}</div>;
        $[43] = t12;
        $[44] = t8;
        $[45] = t2;
      } else {
        t2 = $[45];
      }
      T1 = CollapsibleContent;
      T0 = SidebarMenuSub;
      let t13;
      if ($[46] !== currentRoute) {
        t13 = child_1 => <SidebarLeafItem key={child_1.route || child_1.name} item={child_1} currentRoute={currentRoute} isSubItem={true} />;
        $[46] = currentRoute;
        $[47] = t13;
      } else {
        t13 = $[47];
      }
      t1 = visibleChildren.map(t13);
    }
    $[0] = currentRoute;
    $[1] = expandedSections;
    $[2] = hasChildren;
    $[3] = isMobile;
    $[4] = item;
    $[5] = sectionId;
    $[6] = setOpenMobile;
    $[7] = toggleSection;
    $[8] = T0;
    $[9] = T1;
    $[10] = T2;
    $[11] = T3;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    T0 = $[8];
    T1 = $[9];
    T2 = $[10];
    T3 = $[11];
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[48] !== T0 || $[49] !== t1) {
    t6 = <T0>{t1}</T0>;
    $[48] = T0;
    $[49] = t1;
    $[50] = t6;
  } else {
    t6 = $[50];
  }
  let t7;
  if ($[51] !== T1 || $[52] !== t6) {
    t7 = <T1>{t6}</T1>;
    $[51] = T1;
    $[52] = t6;
    $[53] = t7;
  } else {
    t7 = $[53];
  }
  let t8;
  if ($[54] !== T2 || $[55] !== t2 || $[56] !== t7) {
    t8 = <T2>{t2}{t7}</T2>;
    $[54] = T2;
    $[55] = t2;
    $[56] = t7;
    $[57] = t8;
  } else {
    t8 = $[57];
  }
  let t9;
  if ($[58] !== T3 || $[59] !== t3 || $[60] !== t4 || $[61] !== t8) {
    t9 = <T3 open={t3} className={t4}>{t8}</T3>;
    $[58] = T3;
    $[59] = t3;
    $[60] = t4;
    $[61] = t8;
    $[62] = t9;
  } else {
    t9 = $[62];
  }
  return t9;
}